<template>
    <div class="nav">
        <div :class="!show ? 'column__left' : 'column__left active'">
            <div class="social left">
                <span>-</span>
                <span>-</span>
                <span>Progress</span>
                <span>In</span>
                <span>Work</span>
            </div>
        </div>
        <div :class="!show ? 'column__right' : 'column__right active'">
            <div class="social">
                <span>instagram</span>
                <span>linkedin</span>
                <span>github</span>
                <span>twitter</span>
                <span>codepen</span>
            </div>
        </div>
        <div class="navbar">
            <div class="menuBtn">
                <span :class="!show ? 'navbar__menu' : 'navbar__menu active'" @click="show = !show">Menu</span>
                <span :class="!show ? 'navbar__menu__close active' : 'navbar__menu__close'"
                    @click="show = !show">Close</span>
            </div>
            <span :class="!show ? 'navbar__menu__contact' : 'navbar__menu__contact active'">
                Contact me<br>
                ale.mastropasqua.jb@gmail.com
            </span>
        </div>
    </div>
</template>
  
  
<script>
export default {
    name: "Navbar",
    data() {
        return {
            show: false,
        };
    },
};
</script>
  
<style lang="scss">
.menuBtn {
    display: flex;
    flex-direction: column;
}

.social {
    display: flex;
    flex-direction: column-reverse;
    color: #101010;
    font-size: clamp(20px,2vw,60px);
    font-weight: bold;
    height: 100vh;
    padding: clamp(20px, 4vw, 50px);

    &.left {
        color: #fffdf9;
    }
}

.nav {
    position: fixed;
    width: 100%;
    z-index:3;
    &bar {
        display: flex;
        align-items: flex-end;
        align-content: flex-end;
        flex-direction: row-reverse;
        align-items: center;
        width: 100vw;
        height: 10vh;
        gap: 30px;
        position: fixed;
        top: 0;
        padding: 0 2%;

        &__menu {
            overflow: hidden;
            height: 10vh;
            font-size: clamp(40px, 4vw, 100px);//
            cursor: pointer;
            transition: all 0.3s ease-in;

            &__close {
                overflow: hidden;
                color: #101010;
                font-size: clamp(40px, 4vw, 100px);
                transition: all 0.3s ease-in;
                cursor: pointer;
                height: 10vh;

                &.active {
                    height: 0;

                }
            }

            &.active {
                height: 0;

            }

            &__contact {
                font-family: 'Courier New', Courier, monospace;
                font-size: clamp(9px, 1.1vw, 50px);
                font-weight: 500;

                &.active {
                    color: #101010;
                }
            }


        }
    }
}

.column__left {
    overflow: hidden;
    position: absolute;
    bottom: 0;
    height: 0;
    background: #101010;
    width: 50vw;
    left: 0;
    top:0;
    transition: all 0.3s ease-in;
}

.column__left.active {
    height: 100vh;bottom:0;
}

.column__right {
    overflow: hidden;
    position: absolute;
    height: 0;
    background: #fffdf9;
    height: 100vh;
    width:0;
    right: 0;
    top:0;
    transition: all 0.3s ease-in;
}

.column__right.active {
    width: 50vw;
    top: 0;
}
@media screen and (max-width: 630px) {
.navbar__menu__contact.active {
    display: none;
}
}
</style>